import React from 'react' // this is not optional!
import log from './logging'

import {Provider} from 'react-redux'
import {HeadProvider} from 'react-head'
import {PersistGate} from 'redux-persist/lib/integration/react'

// CSS stuff (ATTENTION: ORDER MATTERS IN PRODUCTION MODE!!!)
import 'libjs/semantic-ui-css/semantic.css'
import './styles/main.scss'

import {View, BootLoader} from './templating/view'

log.startup('creating App and initializing ...')

//XXX: use a ErrorBoundary toplevel here?
const BrowserApp = ({store, persistor}) => (
  <PersistGate persistor={persistor} loading={<BootLoader />}>
    <Provider store={store}>
      <HeadProvider>
        <View />
      </HeadProvider>
    </Provider>
  </PersistGate>
)

const ExpressApp = (store, headTags = []) => (
  <Provider store={store}>
    <HeadProvider headTags={headTags}>
      <View />
    </HeadProvider>
  </Provider>
)

export {BrowserApp, ExpressApp}
